/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".app[_ngcontent-%COMP%]{font-size:medium}\n/*# sourceMappingURL=log-out.component.css.map*/"];
export { styles as styles };
